import { render, staticRenderFns } from "./AvatarIcon.vue?vue&type=template&id=6eb5db26&scoped=true&"
import script from "./AvatarIcon.vue?vue&type=script&lang=js&"
export * from "./AvatarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb5db26",
  null
  
)

export default component.exports